import { ClienteAnaliseMercadoPerspectiva, isPerspectivaRAP, isPerspectivaClassificacao, isPerspectivaProjetada } from '../../perspectivas/cliente-analise-mercado-perspectiva';

export class ClienteAnaliseMercadoFormModalData {
    idCliente: number;
    ano: number;

    // Perspectiva
    perspectiva: ClienteAnaliseMercadoPerspectiva;
    isPerspectivaRAP: boolean;
    isPerspectivaClassificacao: boolean;
    isPerspectivaProjetada: boolean;

    constructor(idCliente: number, ano: number, perspectiva: ClienteAnaliseMercadoPerspectiva) {
        this.idCliente = idCliente;
        this.ano = ano;
        this.setPerspectiva(perspectiva);
    }

    private setPerspectiva(perspectiva: ClienteAnaliseMercadoPerspectiva) {
        this.perspectiva = perspectiva;
        this.isPerspectivaRAP = isPerspectivaRAP(perspectiva.id);
        this.isPerspectivaClassificacao = isPerspectivaClassificacao(perspectiva.id);
        this.isPerspectivaProjetada = isPerspectivaProjetada(perspectiva.id);
    }
}
